export function render() {
	/* Define close bio function */
	const closeBio = (openCard) => {
		if ( ! openCard) {
			return;
		}
		/* Remove the bio-visible class from the card */
		openCard.classList.remove( "bio-visible" );
		/* Toggle the aria-hidden attribute on the bio */
		const bio = openCard.querySelector( ".bio" );
		bio.setAttribute( "aria-hidden", "true" );
	};
	/* Define toggle bio function */
	const toggleBio = (card) => {
		if ( ! card) {
			return;
		}
		/* Toggle the bio-visible class to the card */
		card.classList.toggle( "bio-visible" );
		/* Toggle the aria-hidden attribute on the bio */
		const bio = card.querySelector( ".bio" );
		if (bio) {
			const ariaHidden = bio.getAttribute( "aria-hidden" );
			if (ariaHidden === "true") {
				bio.setAttribute( "aria-hidden", "false" );
			} else {
				bio.setAttribute( "aria-hidden", "true" );
			}
		}
	};

	/* Find all people cards */
	const peopleCards = document.querySelectorAll( ".card-person" );
	/* Loop through each card and add event listeners */
	for (const peopleCard of peopleCards) {
		peopleCard.addEventListener(
			"click",
			() => {
				// Check if the card is already open and close it if it is
				if (peopleCard.classList.contains( "bio-visible" )) {
					closeBio( peopleCard );
					return;
				}
        /* Close any open cards */
				const openCards = document.querySelectorAll( ".bio-visible" );
				for (const openCard of openCards) {
					closeBio( openCard );
				}
        /* Toggle the bio-visible class on the card */
				toggleBio( peopleCard );
			}
		);
	}
}
